const en = {
  dismiss: "Dismiss"
};
export {
  en as default
};
//# sourceMappingURL=en.es.js.map
